import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import { defaultsDeep } from 'lodash';

import {
  STYLING_KEY_LABEL,
  STYLING_KEY_STATIC_TEXT,
  STYLING_KEY_TEXTFIELD,
  STYLING_KEY_QUESTION_TEXT,
  STYLING_KEY_OPTION_TEXT,
  STYLING_KEY_BUTTON,
  STYLING_KEY_PAGE,
  STYLING_KEY_BODY,
  STYLING_KEY_BLOCK,
} from 'sharedParts/constants/stylingKey';

import ActionsTypes from '../const/ActionsTypes';
import {
  FONT_SIZE_KEY,
  FONT_FAMILY_KEY,
  FONT_COLOR_KEY,
  FONT_WEIGHT_KEY,
  FONT_STYLE_KEY,
  SELECTION_COLOR_KEY,
  STICK_TO_KEY,
  TEXT_TRANSFORM_KEY,
  TEXT_DECORATION_KEY,
  BORDER_WIDTH_KEY,
  BORDER_STYLE_KEY,
  BORDER_RADIUS_KEY,
  BORDER_COLOR_KEY,
  BACKGROUND_COLOR_KEY,
  BACKGROUND_IMAGE_KEY,
  BACKGROUND_POSITION_KEY,
  MARGIN_KEY,
} from '../const/StylingSettingKeys';
import defaultLocalStyling from '../config/defaultLocalStyling';
import Constants from '../../../constants/actions';

const LocalStyleReducerFactory = (groupKey, stylingKey) => {
  return (state, { payload }) => {
    return update(state, {
      [groupKey]: {
        [stylingKey]: { $set: payload },
      },
    });
  };
};

const setLocalStylingValue = stylingKey => (state, { payload }) =>
  update(state, { [stylingKey]: { $set: payload } });

export default handleActions(
  {
    [Constants.SET_EDITOR_ACTIVE_SURVEY]: (state, { payload }) =>
      update(state, {
        $set: defaultsDeep({}, payload.localStyling, defaultLocalStyling),
      }),
    [ActionsTypes.SET_LOCAL_STYLING]: (state, { payload }) =>
      update(state, {
        $set: defaultsDeep({}, payload, defaultLocalStyling),
      }),
    [ActionsTypes.SET_LOCAL_LABEL_FONT_COLOR]: LocalStyleReducerFactory(
      STYLING_KEY_LABEL,
      FONT_COLOR_KEY,
    ),
    [ActionsTypes.SET_LOCAL_LABEL_FONT_SIZE]: LocalStyleReducerFactory(
      STYLING_KEY_LABEL,
      FONT_SIZE_KEY,
    ),
    [ActionsTypes.SET_LOCAL_LABEL_FONT_STYLE]: LocalStyleReducerFactory(
      STYLING_KEY_LABEL,
      FONT_STYLE_KEY,
    ),
    [ActionsTypes.SET_LOCAL_LABEL_FONT_WEIGHT]: LocalStyleReducerFactory(
      STYLING_KEY_LABEL,
      FONT_WEIGHT_KEY,
    ),
    [ActionsTypes.SET_LOCAL_LABEL_STICK_TO]: LocalStyleReducerFactory(
      STYLING_KEY_LABEL,
      STICK_TO_KEY,
    ),
    [ActionsTypes.SET_LOCAL_LABEL_TEXT_DECORATION]: LocalStyleReducerFactory(
      STYLING_KEY_LABEL,
      TEXT_DECORATION_KEY,
    ),
    [ActionsTypes.SET_LOCAL_LABEL_TEXT_TRANSFORM]: LocalStyleReducerFactory(
      STYLING_KEY_LABEL,
      TEXT_TRANSFORM_KEY,
    ),
    [ActionsTypes.SET_LOCAL_SELECTION_COLOR]: setLocalStylingValue(
      SELECTION_COLOR_KEY,
    ),
    [ActionsTypes.SET_STATIC_TEXT_FONT_SIZE]: LocalStyleReducerFactory(
      STYLING_KEY_STATIC_TEXT,
      FONT_SIZE_KEY,
    ),
    [ActionsTypes.SET_STATIC_TEXT_FONT_FAMILY]: LocalStyleReducerFactory(
      STYLING_KEY_STATIC_TEXT,
      FONT_FAMILY_KEY,
    ),
    [ActionsTypes.SET_STATIC_TEXT_FONT_COLOR]: LocalStyleReducerFactory(
      STYLING_KEY_STATIC_TEXT,
      FONT_COLOR_KEY,
    ),
    [ActionsTypes.SET_STATIC_TEXT_FONT_STYLE]: LocalStyleReducerFactory(
      STYLING_KEY_STATIC_TEXT,
      FONT_STYLE_KEY,
    ),
    [ActionsTypes.SET_STATIC_TEXT_FONT_WEIGHT]: LocalStyleReducerFactory(
      STYLING_KEY_STATIC_TEXT,
      FONT_WEIGHT_KEY,
    ),
    [ActionsTypes.SET_STATIC_TEXT_DECORATION]: LocalStyleReducerFactory(
      STYLING_KEY_STATIC_TEXT,
      TEXT_DECORATION_KEY,
    ),
    [ActionsTypes.SET_STATIC_TEXT_TRANSFORM]: LocalStyleReducerFactory(
      STYLING_KEY_STATIC_TEXT,
      TEXT_TRANSFORM_KEY,
    ),
    [ActionsTypes.SET_LOCAL_TEXTFIELD_BACKGROUND_COLOR]: LocalStyleReducerFactory(
      STYLING_KEY_TEXTFIELD,
      BACKGROUND_COLOR_KEY,
    ),
    [ActionsTypes.SET_LOCAL_TEXTFIELD_BORDER_COLOR]: LocalStyleReducerFactory(
      STYLING_KEY_TEXTFIELD,
      BORDER_COLOR_KEY,
    ),
    [ActionsTypes.SET_LOCAL_TEXTFIELD_BORDER_RADIUS]: LocalStyleReducerFactory(
      STYLING_KEY_TEXTFIELD,
      BORDER_RADIUS_KEY,
    ),
    [ActionsTypes.SET_LOCAL_TEXTFIELD_BORDER_STYLE]: LocalStyleReducerFactory(
      STYLING_KEY_TEXTFIELD,
      BORDER_STYLE_KEY,
    ),
    [ActionsTypes.SET_LOCAL_TEXTFIELD_BORDER_WIDTH]: LocalStyleReducerFactory(
      STYLING_KEY_TEXTFIELD,
      BORDER_WIDTH_KEY,
    ),
    [ActionsTypes.SET_LOCAL_TEXTFIELD_FONT_COLOR]: LocalStyleReducerFactory(
      STYLING_KEY_TEXTFIELD,
      FONT_COLOR_KEY,
    ),
    [ActionsTypes.SET_LOCAL_TEXTFIELD_FONT_SIZE]: LocalStyleReducerFactory(
      STYLING_KEY_TEXTFIELD,
      FONT_SIZE_KEY,
    ),
    [ActionsTypes.SET_LOCAL_TEXTFIELD_FONT_STYLE]: LocalStyleReducerFactory(
      STYLING_KEY_TEXTFIELD,
      FONT_STYLE_KEY,
    ),
    [ActionsTypes.SET_LOCAL_TEXTFIELD_FONT_WEIGHT]: LocalStyleReducerFactory(
      STYLING_KEY_TEXTFIELD,
      FONT_WEIGHT_KEY,
    ),
    [ActionsTypes.SET_LOCAL_TEXTFIELD_TEXT_DECORATION]: LocalStyleReducerFactory(
      STYLING_KEY_TEXTFIELD,
      TEXT_DECORATION_KEY,
    ),
    [ActionsTypes.SET_LOCAL_TEXTFIELD_TEXT_TRANSFORM]: LocalStyleReducerFactory(
      STYLING_KEY_TEXTFIELD,
      TEXT_TRANSFORM_KEY,
    ),
    [ActionsTypes.SET_QUESTION_TEXT_FONT_COLOR]: LocalStyleReducerFactory(
      STYLING_KEY_QUESTION_TEXT,
      FONT_COLOR_KEY,
    ),
    [ActionsTypes.SET_QUESTION_TEXT_FONT_FAMILY]: LocalStyleReducerFactory(
      STYLING_KEY_QUESTION_TEXT,
      FONT_FAMILY_KEY,
    ),
    [ActionsTypes.SET_QUESTION_TEXT_FONT_SIZE]: LocalStyleReducerFactory(
      STYLING_KEY_QUESTION_TEXT,
      FONT_SIZE_KEY,
    ),
    [ActionsTypes.SET_QUESTION_TEXT_FONT_STYLE]: LocalStyleReducerFactory(
      STYLING_KEY_QUESTION_TEXT,
      FONT_STYLE_KEY,
    ),
    [ActionsTypes.SET_QUESTION_TEXT_FONT_WEIGHT]: LocalStyleReducerFactory(
      STYLING_KEY_QUESTION_TEXT,
      FONT_WEIGHT_KEY,
    ),
    [ActionsTypes.SET_QUESTION_TEXT_DECORATION]: LocalStyleReducerFactory(
      STYLING_KEY_QUESTION_TEXT,
      TEXT_DECORATION_KEY,
    ),
    [ActionsTypes.SET_QUESTION_TEXT_TRANSFORM]: LocalStyleReducerFactory(
      STYLING_KEY_QUESTION_TEXT,
      TEXT_TRANSFORM_KEY,
    ),
    [ActionsTypes.SET_OPTION_TEXT_FONT_SIZE]: LocalStyleReducerFactory(
      STYLING_KEY_OPTION_TEXT,
      FONT_SIZE_KEY,
    ),
    [ActionsTypes.SET_OPTION_TEXT_FONT_FAMILY]: LocalStyleReducerFactory(
      STYLING_KEY_OPTION_TEXT,
      FONT_FAMILY_KEY,
    ),
    [ActionsTypes.SET_OPTION_TEXT_FONT_COLOR]: LocalStyleReducerFactory(
      STYLING_KEY_OPTION_TEXT,
      FONT_COLOR_KEY,
    ),
    [ActionsTypes.SET_OPTION_TEXT_FONT_STYLE]: LocalStyleReducerFactory(
      STYLING_KEY_OPTION_TEXT,
      FONT_STYLE_KEY,
    ),
    [ActionsTypes.SET_OPTION_TEXT_FONT_WEIGHT]: LocalStyleReducerFactory(
      STYLING_KEY_OPTION_TEXT,
      FONT_WEIGHT_KEY,
    ),
    [ActionsTypes.SET_OPTION_TEXT_DECORATION]: LocalStyleReducerFactory(
      STYLING_KEY_OPTION_TEXT,
      TEXT_DECORATION_KEY,
    ),
    [ActionsTypes.SET_OPTION_TEXT_TRANSFORM]: LocalStyleReducerFactory(
      STYLING_KEY_OPTION_TEXT,
      TEXT_TRANSFORM_KEY,
    ),
    [ActionsTypes.SET_BUTTON_FONT_SIZE]: LocalStyleReducerFactory(
      STYLING_KEY_BUTTON,
      FONT_SIZE_KEY,
    ),
    [ActionsTypes.SET_BUTTON_FONT_COLOR]: LocalStyleReducerFactory(
      STYLING_KEY_BUTTON,
      FONT_COLOR_KEY,
    ),
    [ActionsTypes.SET_BUTTON_FONT_WEIGHT]: LocalStyleReducerFactory(
      STYLING_KEY_BUTTON,
      FONT_WEIGHT_KEY,
    ),
    [ActionsTypes.SET_BUTTON_FONT_STYLE]: LocalStyleReducerFactory(
      STYLING_KEY_BUTTON,
      FONT_STYLE_KEY,
    ),
    [ActionsTypes.SET_BUTTON_TEXT_DECORATION]: LocalStyleReducerFactory(
      STYLING_KEY_BUTTON,
      TEXT_DECORATION_KEY,
    ),
    [ActionsTypes.SET_BUTTON_TEXT_TRANSFORM]: LocalStyleReducerFactory(
      STYLING_KEY_BUTTON,
      TEXT_TRANSFORM_KEY,
    ),
    [ActionsTypes.SET_BUTTON_BORDER_WIDTH]: LocalStyleReducerFactory(
      STYLING_KEY_BUTTON,
      BORDER_WIDTH_KEY,
    ),
    [ActionsTypes.SET_BUTTON_BORDER_STYLE]: LocalStyleReducerFactory(
      STYLING_KEY_BUTTON,
      BORDER_STYLE_KEY,
    ),
    [ActionsTypes.SET_BUTTON_BORDER_RADIUS]: LocalStyleReducerFactory(
      STYLING_KEY_BUTTON,
      BORDER_RADIUS_KEY,
    ),
    [ActionsTypes.SET_BUTTON_BORDER_COLOR]: LocalStyleReducerFactory(
      STYLING_KEY_BUTTON,
      BORDER_COLOR_KEY,
    ),
    [ActionsTypes.SET_BUTTON_BACKGROUND_COLOR]: LocalStyleReducerFactory(
      STYLING_KEY_BUTTON,
      BACKGROUND_COLOR_KEY,
    ),
    [ActionsTypes.SET_PAGE_BACKGROUND_COLOR]: LocalStyleReducerFactory(
      STYLING_KEY_PAGE,
      BACKGROUND_COLOR_KEY,
    ),
    [ActionsTypes.SET_BODY_BACKGROUND_COLOR]: LocalStyleReducerFactory(
      STYLING_KEY_BODY,
      BACKGROUND_COLOR_KEY,
    ),
    [ActionsTypes.SET_BODY_BACKGROUND_IMAGE]: LocalStyleReducerFactory(
      STYLING_KEY_BODY,
      BACKGROUND_IMAGE_KEY,
    ),
    [ActionsTypes.SET_BODY_BACKGROUND_POSITION]: LocalStyleReducerFactory(
      STYLING_KEY_BODY,
      BACKGROUND_POSITION_KEY,
    ),
    [ActionsTypes.SET_BLOCK_MARGIN]: LocalStyleReducerFactory(
      STYLING_KEY_BLOCK,
      MARGIN_KEY,
    ),
  },
  defaultLocalStyling,
);
